import { Component, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import {
  getDistanceUsingHaversine,
  getFormattedDateTime,
  isLargeScreen,
  sortArrayOfObject,
} from '../../../../../global.variable';
import { AddEditSiteComponent } from '../../../../shared/components/add-edit-site/add-edit-site.component';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { DataCheckService } from '../../../../shared/services/data-check.service';
import { DeviceInfoService } from '../../../../shared/services/device-info.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { ClientsService } from '../../clients/clients.service';
import { IncidentsService } from '../incidents.service';
declare var GuideChimp: any;
declare var bootstrap: any;
@Component({
  selector: 'gtapp-add-incident',
  templateUrl: './add-incident.component.html',
  styleUrl: './add-incident.component.scss',
  standalone: false,
})
export class AddIncidentComponent implements OnInit, OnDestroy {
  incidentDict: any = {
    client: {
      name: 'Client',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    site: { name: 'Site', value: '', edit: false, data: null, tempValue: '' },
    incidentType: {
      name: 'Incident Type',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },

    iDay: {
      name: 'I Day',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    information: {
      name: 'Information',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
  };

  userData: any;

  dialogRef: any;

  siteList: any = [];
  addIncidentButtonPressed: boolean = false;
  isAdmin = this.dataCheckService.isUserAdmin();
  isDispatchUser = this.dataCheckService.isDispatchUser();

  incidentTypeList: any = [];

  todayDate: any = new Date();
  userLocation: any;

  initialDataList: any = {};

  guideChimp: any;

  selectedIncidentTypeList: any = [];
  selectedIncidentTypeIdList: any = [];

  isGuardUserOnMobile = this.dataCheckService?.isGuardUser() && !isLargeScreen;

  constructor(
    private incidentService: IncidentsService,
    private dialogService: ModalDialogueService,
    private clientService: ClientsService,
    private router: Router,
    private dataCheckService: DataCheckService,
    private spinnerService: LoadingSpinnerService,
    private toasterService: ToasterService,
    private deviceInfoService: DeviceInfoService,
    private viewContainerRef: ViewContainerRef,
  ) {
    router.events.subscribe((event: any) => {
      // close dialog boxes if any are open when back is pressed
      if (event.navigationTrigger === 'popstate') {
        this.dialogRef?.close();
      }
    });
  }

  ngOnInit(): void {
    this.incidentDict.iDay.value = getFormattedDateTime();
    this.getIncidentTypes();
    this.onSiteSearch('');
    // this.editField('site');

    const incidentData = JSON.parse(
      localStorage.getItem(btoa('incidentData')) || '{}',
    );
    if (incidentData?.site?.id) {
      this.onSelectSite(incidentData?.site);
    }
    if (incidentData?.information) {
      this.incidentDict.information.value = incidentData?.information;
    }
    if (incidentData?.selectedIncidentTypeList?.length) {
      this.selectedIncidentTypeList = incidentData?.selectedIncidentTypeList;
      this.getIncidentTypeIdList();
    }

    localStorage.removeItem(btoa('incidentData'));

    this.deviceInfoService
      .getGpsCoordinates()
      .then((gps: any) => (this.userLocation = gps));
  }
  ngOnDestroy(): void {
    if (this.addIncidentButtonPressed) return;
    const unsavedData: any = { iDay: this.incidentDict.iDay.value };
    if (this.incidentDict?.site?.data?.id) {
      unsavedData['site'] = this.incidentDict?.site?.data;
    }
    if (this.incidentDict?.information?.value) {
      unsavedData['information'] = this.incidentDict?.information?.value;
    }
    if (this.selectedIncidentTypeList?.length) {
      unsavedData['selectedIncidentTypeList'] = this.selectedIncidentTypeList;
    }

    localStorage.setItem(btoa('incidentData'), JSON.stringify(unsavedData));
  }

  getIncidentTypes(params?: any) {
    this.incidentService.fetchIncidentTypeList(params).subscribe((res: any) => {
      if (res['status'] == 'success') {
        this.incidentTypeList = res['data'];

        this.initialDataList.incidentType = JSON.parse(
          JSON.stringify(res?.data),
        );
      }
    });
  }
  onSearchIncidentType(event: any) {
    this.guideChimp?.stop();
    this.incidentDict.incidentType.tempValue = event.target.value;
    if (event.target.value.length) {
      this.incidentTypeList = this.initialDataList.incidentType?.filter(
        (type: any) =>
          type?.name
            ?.toLowerCase()
            ?.includes(event.target.value?.toLowerCase()),
      );
    } else {
      this.incidentTypeList = this.initialDataList?.incidentType || [];
    }
  }
  onAddIncidentType(index: number) {
    this.spinnerService.show('Adding Incident Type');
    var requestData = { name: this.incidentDict.incidentType.tempValue };
    this.incidentService
      .createIncidentType(requestData)
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            errorMessage: '',
            successMessage: response['message'],
          });
          this.incidentDict.incidentType = {
            name: 'Incident Type',
            value: '',
            edit: false,
            data: null,
            tempValue: '',
          };

          this.selectedIncidentTypeList[index] = {
            ...response?.data,
            isFocused: false,
          };
          this.getIncidentTypeIdList();
          this.getIncidentTypes();
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            errorMessage: response['message'],
            successMessage: '',
          });
        }
      });
  }
  onSelectIncidentType(event: any, index: number) {
    if (event.key === 0) {
      if (this.incidentDict.incidentType.tempValue.length > 0) {
        this.onAddIncidentType(index);
      } else {
        this.toasterService.setMessage({
          errorMessage: "Incident Name can't be empty",
          successMessage: '',
        });
      }
    }
    if (event?.id) {
      this.selectedIncidentTypeList[index] = {
        ...event,
        isFocused: false,
      };
      this.getIncidentTypeIdList();
    }
  }

  onSiteSearch(event?: any) {
    const searchString = event ? event.target.value : '';
    this.incidentDict.site.tempValue = searchString;

    this.clientService
      .searchSites({
        search_str: searchString,
      })
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.siteList = res['data'];
          if (!event) {
            this.initialDataList.site = JSON.parse(
              JSON.stringify(this.siteList),
            );
          }
          this.sortSiteListData();
        }
      });
  }
  async sortSiteListData() {
    if (!this.isGuardUserOnMobile) {
      this.siteList = [...this.siteList]?.splice(0, 10);
      return;
    }
    if (!this.userLocation?.lat) {
      this.userLocation = await this.deviceInfoService.getGpsCoordinates();
    }

    await Promise.all(
      this.siteList?.map((item: any) => {
        const distance =
          getDistanceUsingHaversine(
            this.userLocation?.lat,
            item?.gps?.lat || item?.address?.latitude,
            this.userLocation?.lon,
            item?.gps?.lon || item?.address?.longitude,
          ) || 0;
        item.hDistance = Number(distance);
      }),
    );

    this.siteList = [
      ...sortArrayOfObject(this.siteList, 'hDistance', 'asc'),
    ]?.splice(0, 10);
  }
  onSelectSite(data: any) {
    if (data?.key === 0) {
      this.openAddSiteForm();
    }

    this.selectedIncidentTypeList = [];

    if (data?.id) {
      this.incidentDict.site.value = data?.company_name;
      this.incidentDict.site.data = data;

      if (data?.company) {
        this.incidentDict.client.value = data?.company?.company_name;
        this.incidentDict.client.data = data?.company;
      }

      this.shiftFocus('iTypeLookupField');

      if (!this.selectedIncidentTypeList?.length) {
        this.selectedIncidentTypeList.push({ isFocused: true });
      }
      this.showIncidentTypeToolTip();
    }
  }
  openAddSiteForm() {
    this.dialogRef = this.dialogService.open(AddEditSiteComponent, {
      data: {
        detailData: { company_name: this.incidentDict.site.tempValue },
      },
    });
    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value !== 'close') {
        this.onSelectSite(value);
      }
    });
  }
  onAddIncident() {
    this.spinnerService.show('Logging new incident');
    this.getIncidentTypeIdList();

    this.addIncidentButtonPressed = true;
    let dateTime = new Date(this.incidentDict.iDay.value);

    let incidentData = {
      site_id: this.incidentDict?.site?.data?.id,
      incident_time: dateTime,
      incident_type: this.selectedIncidentTypeIdList,
      information: this.incidentDict?.information?.value,
    };

    this.incidentService.addIncident(incidentData).then((response: any) => {
      if (response['status'] == 'success') {
        if (response?.data)
          this.router.navigate([
            '/view-incident',
            { inKey: String(response?.data?.id) },
          ]);
      } else {
        this.addIncidentButtonPressed = false;
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
      }

      this.spinnerService.hide();
    });
  }

  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 200);
  }

  formateStartDate(event: any) {
    if (event.target.value) {
      this.incidentDict.iDay.value = event.target.value;
    } else {
      this.incidentDict.iDay.value = getFormattedDateTime();
    }
  }
  editField(field: string) {
    if (field == 'site') {
      this.incidentDict.site = {
        name: 'Site',
        value: '',
        edit: false,
        data: null,
        tempValue: '',
      };
      this.incidentDict.client = {
        name: 'Client',
        value: '',
        edit: false,
        data: null,
        tempValue: '',
      };
      this.shiftFocus('siteId');
    }

    if (field == 'it') {
      this.incidentDict.incidentType = {
        name: 'Incident Type',
        value: '',
        edit: false,
        data: null,
        tempValue: '',
      };

      this.shiftFocus('iTypeLookupField');
      this.showIncidentTypeToolTip();
    }

    this.updateInitialDataList(field);
  }
  updateInitialDataList(field: any) {
    setTimeout(() => {
      if (field === 'site') {
        this.siteList = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
        this.sortSiteListData();
      } else if (field === 'it') {
        this.incidentTypeList = JSON.parse(
          JSON.stringify(this.initialDataList?.incidentType || []),
        );
      }
    }, 200);
  }

  showIncidentTypeToolTip() {
    setTimeout(() => {
      const tooltipElement = document.getElementById('incidentTypeToolTipId');
      if (tooltipElement) {
        // Dispose of the existing tooltip instance if it exists
        const existingTooltip = bootstrap.Tooltip.getInstance(tooltipElement);
        if (existingTooltip) {
          existingTooltip.dispose();
        }
        const tooltipInstance = new bootstrap.Tooltip(tooltipElement);
        tooltipInstance?.show();
      }
    }, 500);
  }
  addNewIncidentTypeField() {
    this.selectedIncidentTypeList = this.selectedIncidentTypeList?.filter(
      (element: any) => element?.id,
    );
    this.selectedIncidentTypeList.forEach(
      (element: any) => (element.isFocused = false),
    );
    this.selectedIncidentTypeList.push({ isFocused: true });
    this.incidentTypeList = JSON.parse(
      JSON.stringify(this.initialDataList?.incidentType || []),
    );
    this.incidentTypeList = this.incidentTypeList?.filter(
      (iType: any) =>
        !this.selectedIncidentTypeList?.some(
          (selectedIType: any) => selectedIType?.id == iType?.id,
        ),
    );
    this.shiftFocus('iTypeLookupField');
    this.getIncidentTypeIdList();
  }
  deleteIncidentTypeField(index: number) {
    this.selectedIncidentTypeList.splice(index, 1);
    if (!this.selectedIncidentTypeList?.length) {
      this.selectedIncidentTypeList.push({ isFocused: true });
      this.shiftFocus('iTypeLookupField');
    }
    this.getIncidentTypeIdList();
  }
  openIncidentTypeLookup(index: number) {
    this.selectedIncidentTypeList[index] = {
      isFocused: true,
    };
    this.shiftFocus('iTypeLookupField');
    this.incidentTypeList = JSON.parse(
      JSON.stringify(this.initialDataList?.incidentType || []),
    );
    this.incidentTypeList = this.incidentTypeList?.filter(
      (iType: any) =>
        !this.selectedIncidentTypeList?.some(
          (selectedIType: any) => selectedIType?.id == iType?.id,
        ),
    );
    this.getIncidentTypeIdList();
  }
  getIncidentTypeIdList() {
    const listWithIds = this.selectedIncidentTypeList?.filter(
      (iType: any) => iType?.id,
    );
    this.selectedIncidentTypeIdList = [
      ...new Set(listWithIds?.map((iType: any) => iType?.id)),
    ];
  }
  openTemplate(template: any, _type: string) {
    this.dialogService.open(template, { data: _type }, this.viewContainerRef);
  }
  onInput(fieldId: string, clear = false) {
    const maxHeight = 150;
    const textarea = document.getElementById(fieldId) as HTMLTextAreaElement;
    if (clear) textarea.value = '';

    textarea.style.height = 'auto';

    const newHeight = Math.max(
      62.5,
      Math.min(textarea.scrollHeight, maxHeight),
    );

    textarea.style.height = `${newHeight}px`;
    textarea.style.overflowY =
      textarea.scrollHeight > maxHeight ? 'auto' : 'hidden';
    textarea.style.fontSize = '0.9rem';
  }
  clearAndFocusTextBox(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      this.onInput(elementId, true);
      element?.focus();
    }, 100);
  }
  checkAndAddIncidentType(index: number) {
    if (
      this.incidentDict?.incidentType?.tempValue?.length > 0 &&
      !this.incidentTypeList?.length
    ) {
      this.onAddIncidentType(index);
    }
  }
}
